//* 组件属性
import type { TutorialsData } from "../index";
import { useOptions } from "./options";

export const useComposable = () => {
    //* 配置项
    const options = useOptions();
    //* 响应式数据
    const refs = {
        mode: ref<"video" | "graphic">("video"),
        data: ref<TutorialsData[]>([]),
        keyword: ref<string>(""),
    };

    //* 函数
    const methods = {
        init: () => {
            refs.keyword.value = "";
            if (refs.mode.value == "graphic") refs.data.value = options.graphics;
            else {
                refs.data.value = options.videos;
            }
        },
    };

    //* 计算属性
    const computeds = {
        data: computed(() => {
            const keyword = refs.keyword.value.trim().toLowerCase();
            if (!keyword) return refs.data.value;
            else {
                return refs.data.value.filter((v) => v.name.toLowerCase().includes(keyword));
            }
        }),
    };

    return { refs, methods, options, computeds };
};
